// extracted by mini-css-extract-plugin
var _1 = "UserEmailEditStep_text__KxLk5";
export { _1 as "text" }
